module.exports = __webpack_public_path__ + "static/media/collaborate..05ddd9c5.svg";